import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CorrelationIdStore } from '../services/correlation-id.store';
import { environment } from '../../../environments/environment';

export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isXapiRequest(req.url)) {
    return next(req);
  }

  const correlationIdStore = inject(CorrelationIdStore);
  const correlationId = correlationIdStore.getNewCorrelationId();

  const requestWithCorrelationId = req.clone({
    setHeaders: {
      'x-correlation-id': correlationId,
    },
  });

  return next(requestWithCorrelationId);
};

function isXapiRequest(url: string): boolean {
  const xapiBase = String(environment.baseUrlXapiCl ?? '').trim();
  if (!xapiBase) return false;

  const normalizedBase = xapiBase.replace(/\/+$/, '');
  return url.startsWith(normalizedBase);
}
